import styled from 'styled-components';
import { devices } from '../../constant';

export const LoginContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PostListContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5%;

    @media ${devices.tablet} {
        margin: 16% 4%;
    }
`;

export const Form = styled.form`
    padding: 5%;
    margin: 5%;
    border: 1px solid black;
    border-radius: 10px;

    @media ${devices.tablet} {
        margin: 16% 4%;
    }
`;

export const TableContainer = styled.table`
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 75%;
`;

export const TableTh = styled.th`
    border: 1px solid #dddddd;
    text-align: center;
    padding: 8px;
`;

export const TableTd = styled.td`
    border: 1px solid #dddddd;
    text-align: ${({ isPost = false }) => isPost ? 'left' : 'center'};
    padding: 8px;
`;

export const TableTr = styled.tr``;

export const TableButton = styled.button`
    cursor: pointer;
    background-color: transparent;
    border: none;
`;
